<template>
	<div class="content-wrapper">
		<div class="sf-flex-column">
			<!-- 조회부분 시작 -->
			<div class="sf-col sf-col-9">
				<sf-card class="p-0 h-100 card_bg">
					<pc-clm-top-search ref="search" @OpenOpPopup="OpenOpPopup" :scrId="scrId"></pc-clm-top-search>
				</sf-card>
			</div>
			<!-- 조회부분 끝 -->

			<!-- 그리드 부분 시작 -->
			<div class="sf-col sf-col-17">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<pc-clm-top-table ref="table" @Refresh="Refresh" :scrId="scrId"></pc-clm-top-table>
				</sf-card>
			</div>
			<!-- 그리드 부분 끝 -->

			<com-cd-popup ref="comCdPopup" @SendData="sendData2" @Refresh="Refresh" :scrId="scrId"></com-cd-popup>
		</div>
	</div>
</template>

<script>
import PcClmTopSearch from './Search/PcClmTopSearch.vue';
import PcClmTopTable from './Table/PcClmTopTable.vue';
import ComCdPopup from '@/views/qms/comm/commpopup/ComCdPopup/ComCdPopup.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	created() {
		console.clear();
	},
	components: { PcClmTopSearch, PcClmTopTable, ComCdPopup },
	methods: {
		Refresh() {
			this.$refs.search.searchList();
		},
		OpenOpPopup(commCd) {
			this.$refs.comCdPopup.open(commCd); //.open(param);
		},
		sendData2(param) {
			//this.setSearchParam_({ key: 'opCd', value: param.commCd });
			this.$refs.search.setSearchParam({ key: 'opCd', value: param.commCd });
			this.$refs.search.setSearchParam({ key: 'opCdNm', value: param.commCdName });
		}
	}
};
</script>

<style></style>
